import { IconType } from "@common/declarations";
import React, { useContext } from "react";
import { RichEditorContext } from "../context";
import MenuButtonBase from "./Base";

const FullScreenButton = () => {
  const context = useContext(RichEditorContext);

  return (
    <MenuButtonBase
      icon={context.isFullScreen ? IconType.ExitFullscreen : IconType.Fullscreen}
      isActive={context.isFullScreen}
      onMouseDown={context.toggleFullScreen}
    />
  );
};
export default FullScreenButton;
